import dayjs from "dayjs";
import React, { useState } from "react";

import DateStrip from "./DateStrip";
import CalendarDialog from "./CalendarDialog";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveChosenDate } from "../../../../features/mobile/commonSlice";

const CalendarHeader = ({
  type,
  startDate,
  setStartDate,
  chosenDate,
  // setChosenDate,
  existDaysOfYear,
  mealDates,
  otherRecordDates,
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  dayjs.locale("en");
  const backgroundColor = {
    RECORD_COMPLETE: "bg-[#417FFF]",
    MEAL_RECORD: "bg-[#417FFF]",
    WEIGHT_RECORD: "bg-[#FFC700]",
    SYMPTOM_RECORD: "bg-[#847CE9]",
    MEDICATION_REMINDER: "bg-[#01B68B]",
    APPOINTMENT_REMINDER: "bg-[#51CCF3]",
    STEPS: "bg-[#FE718E]",
  };

  const handleChange = (date) => {
    setStartDate(date);
    dispatch(saveChosenDate(dayjs(date).format("YYYY-MM-DD")));
    setOpenCalendar(false);
  };

  return (
    <>
      <div
        className={`w-full flex justify-center ${backgroundColor[type]} ${type === "RECORD_COMPLETE" ? "safe-area-top" : "safe-area-mt-header-exact"}`}
      >
        <div className="w-full max-w-[768px]">
          <div
            className={`flex h-[60px] items-center justify-between px-6 py-3 ${backgroundColor[type]}`}
          >
            <span className="text-center text-xl font-semibold text-white">
              {type === "RECORD_COMPLETE" ? (
                <span className="text-[32px] font-extrabold">
                  {dayjs(chosenDate || startDate).format("MMM")}
                </span>
              ) : (
                dayjs(chosenDate || startDate).format("YYYY. MM. DD")
              )}
            </span>
            <div className="flex gap-3">
              <img
                src="/images/mobile/home/new_calendar.svg"
                alt="calendar icon"
                onClick={() => setOpenCalendar(true)}
                className="h-6 w-6 cursor-pointer"
              />
              {type === "RECORD_COMPLETE" && (
                <>
                  <img
                    onClick={() => navigate(`/mypage`)}
                    src={"/images/mobile/home/new_hamburger.svg"}
                    alt="menu"
                    className="h-6 w-6 cursor-pointer"
                  />
                </>
              )}
            </div>
          </div>

          <div className={`px-4 py-[10px] ${backgroundColor[type]}`}>
            <DateStrip
              type={type}
              startDate={startDate}
              setStartDate={setStartDate}
              chosenDate={chosenDate}
              handleChange={handleChange}
              existDates={[...existDaysOfYear]}
              mealDates={mealDates || []}
              otherRecordDates={otherRecordDates || []}
            />
          </div>

          <div className={`h-[28px] ${backgroundColor[type]}`}></div>
        </div>
      </div>
      <CalendarDialog
        type={type}
        startDate={startDate}
        setStartDate={setStartDate}
        handleChange={handleChange}
        chosenDate={chosenDate}
        existDates={[...existDaysOfYear]}
        mealDates={mealDates || []}
        otherRecordDates={otherRecordDates || []}
        openCalendar={openCalendar}
        setOpenCalendar={setOpenCalendar}
      />
    </>
  );
};

export default CalendarHeader;
